import { render, staticRenderFns } from "./StatsFieldDialog.vue?vue&type=template&id=15b5b96a&scoped=true&"
import script from "./StatsFieldDialog.vue?vue&type=script&lang=js&"
export * from "./StatsFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./StatsFieldDialog.vue?vue&type=style&index=0&id=15b5b96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b5b96a",
  null
  
)

export default component.exports